import { Component, EventEmitter, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { TranslateModule } from "@ngx-translate/core";
import { User } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@entities/app/user.entity';
import { Router } from '@angular/router';
import RoutesConstants from '../../../@commons/constants/routes.constants';
import { BookIcon } from '../../../@icons/book-icon';
import { BellIconComponent } from '../../../@icons/bell-icon.component';
import { SmartAlertsApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/smart-alerts/smart-alerts-api';

@Component({
  selector: 'vw-header-home',
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    BookIcon,
    BellIconComponent,
  ],
  providers: [
    { provide: SmartAlertsApi, useClass: SmartAlertsApi },
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
  templateUrl: './header-home.component.html',
  styleUrl: './header-home.component.scss'
})
export class HeaderHomeComponent implements OnInit {
  @Input() user: User;
  @Output() onProfileClick: EventEmitter<void> = new EventEmitter<void>();

  unreadCount = 0;
  today: Date = new Date();

  constructor(
    private router: Router,
    private smartAlertsApi: SmartAlertsApi,
  ) {}

  async ngOnInit() {
    try {
      const result = await this.smartAlertsApi.getUnreadCount();
      this.unreadCount = result?.count ?? 0;
    } catch {
      // Silently fail
    }
  }

  handlerClickOnUserGreeting($event: MouseEvent) {
    this.router.navigate([RoutesConstants.PROFILE]);
  }

  handleGuide($event: MouseEvent) {
    this.router.navigate([RoutesConstants.GARDEN_GUIDE]);
  }

  handleBell($event: MouseEvent) {
    this.router.navigate([RoutesConstants.NOTIFICATIONS]);
  }
}
